/**
 * Do not remove
 * This indicates locale-specific pre-processor which filename to use before building
 * Renaming is done by prepareLocale yarn script and should be run on every locale change
 * @pragma filename('resort.firsthand')
 */
import { ResortLayout } from 'page-components/resort/_layout';
import Component, { getResortFHPageServerSideProps } from 'page-components/resort/firsthand';
import { propsWithI18NSSR } from 'util/propsWithI18n';
/* import { fetchResortSlugs } from 'util/fetchResortSlugs';
import { packPaths } from 'util/packPaths'; */

export default Object.assign(Component, { Layout: ResortLayout });

export const getServerSideProps = propsWithI18NSSR(getResortFHPageServerSideProps);

/* export const getStaticPaths = async () => packPaths((await fetchResortSlugs('resort.firsthand')).map((res) => ({
  region: res.region,
  resort: res.slug,
}))); */
